/**
 * @module js/thumbnailFileUploadService
 */

import eventBus from 'js/eventBus';
import { createHash } from 'node:crypto';
import { Buffer } from 'node:buffer';

export const getSelectedFileInfo = async (fileName, formData, parameters) => {
    return {
        fileNames: fileName,
        fileInputForms: formData,
        isFileValid: parameters.validFile,
        fileType: parameters.fileExt
    };
};

export const updateThumbnailBool = (vmo, validFile) => {
    const { data, dispatch } = vmo;
    data.isThumbnailSelected = validFile;
    dispatch({ path: 'data', value: { ...data } });
};

export const sendDssFileToUpload = async function (accsessionId, thumbnailTicket, formData, fileType, accUrl) {
    const session = decodeAccSession(accsessionId);
    const promises = [];

    const file = formData.file || formData.get('fmsFile');
    const results = await generateSHA256(file);

    const headers = new Headers();
    headers.append('x-siemens-accid', session.accsessionid);
    headers.append('x-siemens-accsessionid', session.accsessionid);
    headers.append('x-siemens-file-md5', results.fileMD5);
    headers.append('x-siemens-file-length', file.size);
    headers.append('x-siemens-file-ticket', thumbnailTicket);
    headers.append('x-siemens-file-content-type', fileType);


    const fd = new FormData();
    fd.append('query', 'mutation { uploadFile }');
    fd.append('variables', '{}');
    fd.append('dssFile', file);
    fd.append('accsessionid', session.accsessionid);
    try {
        promises.push(fetch(accUrl + '/acc/upload', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: fd
        }));
        while (promises.length > 0) {
            const batchSize = 10;
            const batch = promises.splice(0, batchSize);
            await Promise.all(batch);
        }
    } catch (error) {
        console.log(error);
    }
};

const generateSHA256 = async file => {
    const fileBuffer = await readFileAsArrayBuffer(file);
    const fileHash = createHash('sha256').update(Buffer.from(fileBuffer)).digest('base64');

    return {
        file: file,
        fileMD5: fileHash
    };
};

const decodeAccSession = accsessionId => {
    const decoded = decodeBase64Utf8(accsessionId);
    return JSON.parse(decoded);
};

const decodeBase64Utf8 = value => {
    if (typeof atob === 'function') {
        const binary = atob(value);
        const bytes = Uint8Array.from(binary, char => char.codePointAt(0));
        if (typeof TextDecoder !== 'undefined') {
            return new TextDecoder().decode(bytes);
        }
        return binary;
    }
    if (Buffer !== undefined) {
    return Buffer.from(value, 'base64').toString('utf-8');
    }
    throw new Error('Unable to decode base64 acc session id');
};

const readFileAsArrayBuffer = file => file.arrayBuffer();

// upload catalog associated files to DSS
export const uploadCatalogFilestoDss = async (accsessionId, filesAddedUploadTickets, formData, fileType, accUrl) => {
    try {
        const promises = formData.map((element, index) => sendDssFileToUpload(accsessionId, filesAddedUploadTickets[index].data.uploadTicket, element, fileType[index], accUrl));
        await Promise.all(promises);
        eventBus.publish('fileUploadedToDSSSuccess');
    } catch (error) {
        console.log(error);
    }
}

// get files Info of uploaded files in widgets
export const getSelectedFilesInfo = async (fileName, formData, parameters) => {
    const filesInfo = formData.map((file) => {
        return { fileName: file.selectedFile }
    });
    return {
        fileNames: fileName,
        fileInputForms: formData,
        isFileValid: parameters.validFile,
        fileType: parameters.fileExt,
        inputForAddFilesToStagingArea: filesInfo
    };
};
